function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M91.33,95.21a5.73,5.73,0,1,0,5.26,5.72A5.49,5.49,0,0,0,91.33,95.21Zm18.8,0a5.74,5.74,0,1,0,5.25,5.72A5.49,5.49,0,0,0,110.13,95.21Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M135.16,52h-69A10.59,10.59,0,0,0,55.59,62.61v69.63a10.59,10.59,0,0,0,10.56,10.61h58.4l-2.73-9.53,6.59,6.13,6.24,5.76L145.72,155V62.61A10.59,10.59,0,0,0,135.16,52Zm-19.88,67.26s-1.85-2.22-3.4-4.17c6.75-1.91,9.32-6.13,9.32-6.13a29.55,29.55,0,0,1-5.92,3,33.8,33.8,0,0,1-7.47,2.21,36,36,0,0,1-13.33,0A43.74,43.74,0,0,1,86.91,112a30.39,30.39,0,0,1-3.76-1.75c-.16-.11-.31-.16-.47-.26a.7.7,0,0,1-.2-.16c-.93-.51-1.45-.87-1.45-.87s2.48,4.12,9,6.07c-1.55,2-3.45,4.28-3.45,4.28-11.39-.36-15.71-7.83-15.71-7.83a69,69,0,0,1,7.41-30C85.72,75.84,92.78,76,92.78,76l.51.62C84,79.3,79.75,83.36,79.75,83.36s1.13-.61,3-1.49a38.44,38.44,0,0,1,11.69-3.24,4.23,4.23,0,0,1,.87-.11,43.77,43.77,0,0,1,10.4-.1,42.16,42.16,0,0,1,15.51,4.94s-4.07-3.86-12.83-6.54l.72-.82s7.06-.16,14.47,5.41a68.92,68.92,0,0,1,7.42,30S126.66,118.9,115.28,119.26Z"
});

function SvgIconDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = React.forwardRef(SvgIconDiscord);
export default __webpack_public_path__ + "static/media/Icon__Discord.694f69a7.svg";
export { ForwardRef as ReactComponent };